import { makeStyles } from "@material-ui/styles";
import { createMuiTheme } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  spinner: {
    marginLeft: 15,
    position: "relative",
    top: 4,
  },
  link: {
    textDecoration: "none",
    color: theme.palette.primary.main, 
    fontSize: '1rem'
  },
  optionWrapper: {
    display:"flow-root", 
    padding: "4px 5px",
    margin: "0 2px",
    alignItems: "center",
    "&:hover": {
        cursor: "pointer",
        color: theme.palette.secondary.dark
      }
  },
  floatCstm:{
    float:"right",
    display:"flex",
  },
  floatcenter:{
    textAlign:"Center",
  },
  cstmCssbtn:{
    flex: "0 0 auto !important",
    color: "none",
    padding: "6px !important",
    fontSize: "0.875rem !important",
    borderRadius: "0% !important",
  },
  notFoundContainer:{
    display:"flex",
    width:"100%"
  },
  iconboxClass:{
    width:"50%",
    "& svg":{
      width:"90%",
      height:"90%",
      color:"#00a4e7",
    },
  },
  textboxClass:{
    width:"50%",
    padding:"80px",
    "& h1":{
      margin:"0px",
      fontSize: "46px",
      color:"#121a3670",
    },
    "& h2":{
      margin:"0px",
      fontSize: "36px",
      color:"#00a4e7",
    },
    "& p":{
      fontSize:"16px",
    },
  },
  rightBtn:{
    display: "flex",
    justifyContent: "flex-end",
    "& svg":{
      width: "16px",
      height: "16px",
    }
  },
  headRightBtn:{
    padding:"5px 18px",
  },
  statusBg: {
    borderRadius: '2px',
    textTransform: 'uppercase',
    fontSize: '10px',
    fontWeight: '600',
    letterSpacing: '1px',
    paddingRight: '12px',
    paddingLeft: '12px'
  },
}));

export const getMuiTheme = (theme) =>{
  return createMuiTheme({
    ...theme,
    overrides: {
    // MUIDataTableBodyCell:{
    //   root:{
    //     padding:"1px 10px"
    //   }
    //   },
      MuiToolbar: {
        root: {
          padding:0
        },
        gutters:{
          padding:0,
          ["@media (min-width: 600px)"]: {
          padding:0,
          },
        },
        regular:{
          border:"none!important",
          minHeight:"100%",
          ["@media (min-width: 600px)"]: {
          minHeight: "100%",
          },

        }
      },
      MUIDataTableBodyCell: {
        root: {
          padding: "4px",
          // eslint-disable-next-line no-useless-computed-key
          ["@media (min-width:959.5px)"]: {
            padding: "2px 10px",
          },
        },
      },
      MUIDataTableBody:{
        emptyTitle:{
          fontSize:"0.875rem"
        }
      },
      MUIDataTableHeadCell: {
        root: {
          padding: "5px 18px",
        },
        fixedHeader:{
          //backgroundColor:"#f6f6f6",
          
        }
      },
      MuiTableCell:{
        root:{
          fontSize: "0.875rem",
        }
      },
      MuiTypography:{
        body1:{
          fontSize: "0.875rem",
        }
      },
      MuiTablePagination:{
        toolbar:{
          minHeight: "100%"
        }
      },
      MUIDataTablePagination:{
        tableCellContainer:{
          border:"none",
          padding:"0px",
        }
      },
      PrivateSwitchBase: {
        root: {
          padding: "4px 0px 4px 4px",
        },
      },
      MuiIconButton: {
        root: {
          padding: "6px",
          marginLeft: "5px",
        },
      },
      MuiPaper:{
      root:{
        boxShadow:"none"
      },
      elevation1:{
        boxShadow:"none"
      },
      elevation4:{
        boxShadow:"none",
        border: "#cccccc43 solid thin",
        //borderTop: "none",
      },
      rounded:{
        borderRadius:0
      },

    },
    MuiTabScrollButton:{
      root:{
        Mui:{
          disabled:{
            opacity:1
          }
        }
      }
    }
    },
  })};
